export default __webpack_public_path__ + "static/img-sevenx-ventures-fdd28dabb4ecbe9d0adf352ca0121774.png";